import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { CreateQuestion } from "./entities/create-question";
import { QuestionBankController } from "./create-question-controller";
import { QuestionBankService } from "./create-question.service";
import { CreateQuestionAdapter } from "./dtos/create-question.adapter";
import { CreateQuestionRepo } from "./repos/create-question-repo";
import { CollegeCodesAndSymobols } from "./entities/college-codes-symbols.entity";
import { CollegeCodesAndSymbolsRepo } from "./repos/college-codes-symbols.repo";
import { TabQuestion } from "./entities/tab-question.entity";
import { TabQuestionRepo } from "./repos/tab-question.repo";
import { ClassRepo } from "../ai-generated-qp/repo/class-repo";
import { SubjectRepo } from "../ai-generated-qp/repo/subject-repo";
import { ChapterRepo } from "../ai-generated-qp/repo/chapter-repo";
import { TopicRepo } from "../ai-generated-qp/repo/topic-repo";
import { LanguagesRepo } from "../ai-generated-qp/repo/languages-repo";

@Module({
    imports: [TypeOrmModule.forFeature([CreateQuestion, CollegeCodesAndSymobols,TabQuestion])],
    controllers: [QuestionBankController],
    providers: [QuestionBankService, CreateQuestionAdapter, CreateQuestionRepo, CollegeCodesAndSymbolsRepo,TabQuestionRepo, ClassRepo, SubjectRepo, ChapterRepo, TopicRepo,LanguagesRepo],
    exports: [QuestionBankService]
})

export class QuestionBankCreationModule { }